import { ChangeDetectorRef, Component } from '@angular/core';
import { HeaderComponent } from "../../layout/header/header.component";
import { NavbarComponent } from "../../layout/navbar/navbar.component";
import { RoutelinksService } from '../../services/core/routelinks.service';
import { SidebarComponent } from "../../layout/sidebar/sidebar.component";
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LangChangeEvent, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ParamTutitionCalculationDto } from '../../models/tuitionCalculation/paramTutitionCalculationDto';
import { ListProgramOfRegistrationDto } from '../../models/tuitionCalculation/listProgramOfRegistrationDto';
import { ListOptionalAdministrativeFeeDto } from '../../models/tuitionCalculation/listOptionalAdministrativeFeeDto';
import { ListSelectedDiscountDto } from '../../models/tuitionCalculation/listSelectedDiscountDto';
import { SharedService } from '../../services/shared.service';
import { SpinnerModalComponent } from '../spinner-modal/spinner-modal.component';
import { LauncerService } from '../../services/launcer.service';
import { Subscription } from 'rxjs';
import { RateModelDto } from '../../models/ratemodeldto';
import { TuitionCalculationService } from '../../services/tuition-calculation.service';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
import { DataForEnrolmentModificationDto } from '../../models/tuitionCalculation/dataForEnrolmentModificationDto';
import { DataForEnrolmentCancellationDto } from '../../models/tuitionCalculation/dataForEnrolmentCancellationDto';
import { EconomicCalculationResponseDto } from '../../models/tuitionCalculation/economicCalculationResponseDto';
import { CurrentDiscountDto } from '../../models/launcher/currentDiscountDto';
import { OptionalAdministrativeFeeDto } from '../../models/launcher/optionalAdministrativeFeeDto';
import { DiscountsAppliedDto } from '../../models/tuitionCalculation/discountsAppliedDto';
import { GenericRateListComponent } from '../generic-rate-list/generic-rate-list.component';
import { CommonModule } from '@angular/common';
import { TuitionfeesummaryComponent } from '../tuitionfeesummary/tuitionfeesummary.component';
import { PartialTuitionAmountComponent } from '../partial-tuition-amount/partial-tuition-amount.component';
import { LastOperationResultDto } from '../../models/tuitionCalculation/lastOperationResultDto';
import { EnrollmentModificationDto, EnrollmentModificationResponse } from '../../models/enrollment/enrollmentModificationDto';
import { EnrollmentCancellationDto } from '../../models/enrollment/enrollmentCancellationDto';

@Component({
  selector: 'app-tuition-calculation',
  standalone: true,
  imports: [CommonModule, HeaderComponent, NavbarComponent, SidebarComponent, ReactiveFormsModule, TranslatePipe, SpinnerModalComponent,
    ErrorModalComponent, GenericRateListComponent, TuitionfeesummaryComponent, PartialTuitionAmountComponent],
  templateUrl: './tuition-calculation.component.html',
  styleUrl: './tuition-calculation.component.css'
})
export class TuitionCalculationComponent {

  links: any[] = []; // Lista de links para el sidebar

  validateTuitionCalcForm!: FormGroup;

  paramTutitionCalculationDto: ParamTutitionCalculationDto = new ParamTutitionCalculationDto();

  listProgramOfRegistration: ListProgramOfRegistrationDto[] = [];

  listOptionalAdministrativeFee: ListOptionalAdministrativeFeeDto[] = [];

  listSelectedDiscountDto: ListSelectedDiscountDto[] = [];

  dataForEnrolmentModification: DataForEnrolmentModificationDto = new DataForEnrolmentModificationDto();

  dataForEnrolmentCancelation: DataForEnrolmentCancellationDto = new DataForEnrolmentCancellationDto();

  formSubmit!: boolean;

  isProgram!: boolean;

  isSubject!: boolean;

  isDiscountPromotional!: boolean;

  isPatternModification!: boolean;

  isPatternCancellation!: boolean;

  isTaxAdminOptional!: boolean;

  isSelectDiscountSelect!: boolean;

  isPayCompany!: boolean;

  isPayStudent!: boolean;

  currentLanguage: string = 'es';

  langChangeSubscription!: Subscription;

  initRateModelDto: RateModelDto[] = [];

  economicCalculationResponseDto!: EconomicCalculationResponseDto;

  selectDisctNoAcumulative: CurrentDiscountDto[] = [];

  selectDisctAcumulative: CurrentDiscountDto[] = [];

  selectDiscountPromotional: CurrentDiscountDto[] = [];

  selectTaxAdminOptional: OptionalAdministrativeFeeDto[] = [];

  filteredRateModels!: RateModelDto[];

  lastOperationResultDto: LastOperationResultDto | null = null;


  patternModificationReponse!: EnrollmentModificationDto[];

  patternCancellationResponse!: EnrollmentCancellationDto[];

  // Parámetros para el modal de error genérico
  showErrorModal = false;
  errorTitle = '';
  errorMessage = '';

  discountViewModal!: DiscountsAppliedDto;

  constructor(private routelinks: RoutelinksService,
    private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private launcherService: LauncerService,
    private translateService: TranslateService,
    private changeDetector: ChangeDetectorRef,
    private tuitionCalculationService: TuitionCalculationService
  ) {

  }

  ngOnInit(): void {
    this.links = this.routelinks.linksLauncher;
    this.initFormReactiveTuitionCalc();
    this.getParamInit();

    this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang;
      this.changeDetector.detectChanges();
      this.getParamInit();
    });

    // Nos subcribimos para saber que tipo de accion va a realizar
    this.validateTuitionCalcForm.get('discountPromotionalSelect')?.valueChanges
      .subscribe(value => {
        if (value === 'S') {
          this.isDiscountPromotional = true;
        } else {
          this.isDiscountPromotional = false;
          this.validateTuitionCalcForm.patchValue({
            idDiscountPromotionalCode: 0
          });
        }
      });

    this.validateTuitionCalcForm.get('typeOfRegistration')?.valueChanges
      .subscribe(value => {
        if (value === 'P') {
          this.isProgram = true;
          this.isSubject = false;
        } if (value === 'S') {
          this.isProgram = false;
          this.isSubject = true;
        }
      });

    this.validateTuitionCalcForm.get('patternModification')?.valueChanges
      .subscribe(value => {
        if (value === 'S') {
          this.validateTuitionCalcForm.get('patternCancellation')?.disable({ emitEvent: false });
          this.isPatternModification = true;
          if (this.patternModificationReponse == undefined) {
            this.tuitionCalculationService.consultListPatternModification(
              this.validateTuitionCalcForm.get('typology')?.value).subscribe({
                next: response => {
                  if (response.filteredPatternModificationDto.length >= 1) {
                    this.patternModificationReponse = response.filteredPatternModificationDto;
                  }
                }
              })
          }
        } else {
          this.isPatternModification = false;
          this.validateTuitionCalcForm.get('patternCancellation')?.enable({ emitEvent: false });
        }
      });

    this.validateTuitionCalcForm.get('patternCancellation')?.valueChanges
      .subscribe(value => {
        if (value === 'S') {
          this.validateTuitionCalcForm.get('patternModification')?.disable({ emitEvent: false });
          this.isPatternCancellation = true;
          if (this.patternCancellationResponse == undefined) {
            this.tuitionCalculationService.consultListPatternCancellation(this.validateTuitionCalcForm.get('typology')?.value)
              .subscribe({
                next: response => {
                  if (response.filteredPatternCancellationDto.length >= 1) {
                    this.patternCancellationResponse = response.filteredPatternCancellationDto;
                  }
                }
              })
          }
        } else {
          this.isPatternCancellation = false;
          this.validateTuitionCalcForm.get('patternModification')?.enable({ emitEvent: false });
        }
      });

    this.validateTuitionCalcForm.get('taxAdminOptional')?.valueChanges
      .subscribe(value => {
        if (value === 'S') {
          this.isTaxAdminOptional = true;
        } else {
          this.isTaxAdminOptional = false;
          this.validateTuitionCalcForm.patchValue({
            listOptionalAdministrativeFee: [],
            idFeeCodeOptional: null
          })
        }
      });

    this.validateTuitionCalcForm.get('discountSelect')?.valueChanges
      .subscribe(value => {
        if (value === 'S') {
          this.isSelectDiscountSelect = true;
        } else {
          this.isSelectDiscountSelect = false;
          this.validateTuitionCalcForm.patchValue({
            listSelectedDiscount: [],
            idDiscountCode: null
          })
        }
      });

    // Dada la tipología, filtramos los modelos
    this.validateTuitionCalcForm.get('typology')?.valueChanges
      .subscribe(value => {
        // Obtenemos el listado inicial de todos los modelos para su posterior filtrado.
        this.paramTutitionCalculationDto.rateModelDto = this.initRateModelDto;
        const rmFilter = this.paramTutitionCalculationDto.rateModelDto.filter((rm: any) => {
          return rm.typology.includes(value);
        });
        this.filteredRateModels = rmFilter;
      });


    this.validateTuitionCalcForm.get('selectionPayment')?.valueChanges
      .subscribe(value => {
        this.isPayStudent = false;
        this.isPayCompany = false;
        if (value == 1) {
          this.isPayStudent = true;
          // El bloque de compañia debemos de indicarlo a vacío
          this.validateTuitionCalcForm.patchValue({
            companyPaymentPercentage: '',
            companyFixedAmount: '',
            selectedCofrosCompanyPaymentMethodCode: '',
            numberInstallmentsCompanyPaymentMethod: 0,
            firstInstallmentPercentageCompany: 0,
          });
        } else if (value == 2) {
          this.isPayCompany = true;
          // El bloque de estudiante debemos de indicarlo a vacío
          this.validateTuitionCalcForm.patchValue({
            selectedCofrosStudentPaymentMethodCode: '',
            numberInstallmentsStudentPaymentMethod: 0,
            firstInstallmentPercentageStudent: 0,
          });
        } else if (value == 3) {
          this.isPayStudent = true;
          this.isPayCompany = true;
        }
      });

    // Controla la parte de la empresa que solo se pueda utilzar el pago fijo o porcentaje.
    this.validateTuitionCalcForm.get('companyFixedAmount')?.valueChanges
      .subscribe(value => {
        if (value) {
          const cleaned = value.replace(/\D/g, '').slice(0, 30);
          if (value !== cleaned) {
            this.validateTuitionCalcForm.get('companyFixedAmount')?.patchValue(cleaned, { emitEvent: false });
          }
        }
        this.cleanerCompanyFixedAmountOrPercent(true, value);
      });


    this.validateTuitionCalcForm.get('companyPaymentPercentage')?.valueChanges
      .subscribe(value => {
        if (value) {
          const cleaned = value.replace(/\D/g, '').slice(0, 30);
          if (value !== cleaned) {
            this.validateTuitionCalcForm.get('companyPaymentPercentage')?.patchValue(cleaned, { emitEvent: false });
          }
        }
        if (value > 100) {
          this.validateTuitionCalcForm.get('companyPaymentPercentage')?.patchValue(100);
        }
        this.cleanerCompanyFixedAmountOrPercent(false, value);
      });
  }

  getParamInit(): void {
    // Cargamos el listado de los descuentos seleccionables y de promoción
    this.sharedService.initSelectDiscountCalcPotential.subscribe((selectDisct: CurrentDiscountDto[]) => {
      if (selectDisct != null && selectDisct.length >= 1) {
        this.selectDisctNoAcumulative = selectDisct.filter(s => s.accumulativeDiscountIndicator == 'N'
          && s.studentVisibleDiscountIndicator == 'S');
        this.selectDisctAcumulative = selectDisct.filter(s => s.accumulativeDiscountIndicator == 'S'
          && s.studentVisibleDiscountIndicator == 'S');
      }
    });

    // Cargamos el listado de tasas opcionales 
    this.sharedService.initTaxAdminOptionalCalcPotential.subscribe((taxOptional) => {
      if (taxOptional != null && taxOptional.length >= 1) {
        this.selectTaxAdminOptional = taxOptional;
      }
    });

    this.changeLanguageAndOrderSelectRateModel();
    this.changeLanguageOtherSelect();

  }

  private initFormReactiveTuitionCalc(): void {
    this.validateTuitionCalcForm = this.formBuilder.group({
      externalSystemCode: ['', [Validators.required]],
      idUniqueTransactionExternalSystem: ['', [Validators.required]],
      idpStudent: ['', [Validators.required]],
      referenceDate: ['', [Validators.required]],
      typology: ['', Validators.required],
      rateModelCode: ['', Validators.required],
      companyPaymentPercentage: '',
      companyFixedAmount: '',
      selectedCofrosStudentPaymentMethodCode: '',
      numberInstallmentsStudentPaymentMethod: 0,
      firstInstallmentPercentageStudent: 0,
      selectedCofrosCompanyPaymentMethodCode: '',
      numberInstallmentsCompanyPaymentMethod: 0,
      firstInstallmentPercentageCompany: '',
      idDiscountPromotionalCode: [0],
      materialShippingIndicator: ['', [Validators.required]],
      numberTimesModificationFeeAppliedBefore: [''],
      typeOfRegistration: ['', Validators.required],

      dataForEnrolmentModification: this.formBuilder.group({
        behaviourPatternModificationCode: '',
      }),

      dataForEnrolmentCancelation: this.formBuilder.group({
        behaviourPatternCancelationCode: '',
        lastOperationResult: this.lastOperationResultDto
      }),

      listProgramOfRegistration: this.formBuilder.array([
        this.createListProgramGroup()
      ]),

      listSelectedDiscount: this.formBuilder.array([]),
      listOptionalAdministrativeFee: this.formBuilder.array([]),

      idFeeCodeOptional: [],
      idDiscountCode: [],
      discountPromotionalSelect: ['N'],
      patternModification: ['N'],
      patternCancellation: ['N'],
      taxAdminOptional: ['N'],
      discountSelect: ['N'],
      selectionPayment: [''],

    });
  }


  createListProgramGroup(): FormGroup {
    return this.formBuilder.group({
      idProduct: [''],
      academicRateType: ['N'],
      numberTimesProgramRegistered: [0],
      numberCreditsForProgram: [0],
      numberCreditsForProgramRegistration: [0],
      numberCreditsForProgramRegistrationCurrentPeriod: '',
      numberCreditsForProgramRegistrationCompleted: '',
      chargeLearningResourcesBecauseOfAcademicReasons: [0],
      learningResourceType: ['C'],
      numberCreditsCancelled: [''],
    })
  }

  createListAdminOptinal(): FormGroup {
    return this.formBuilder.group({
      idFeeCodeOptional: []
    })
  }

  createListDiscountNoAcumu(): FormGroup {
    return this.formBuilder.group({
      idDiscountCode: []
    })
  }

  createListDiscountAcumu(): FormGroup {
    return this.formBuilder.group({
      idDiscountCode: []
    })
  }

  get listProgramsArray(): FormArray {
    return this.validateTuitionCalcForm.get('listProgramOfRegistration') as FormArray;
  }

  get behaviourPatterModification() {
    return this.validateTuitionCalcForm.get('dataForEnrolmentModification.behaviourPatternModificationCode');
  }

  get behaviourPatternCancellationCode() {
    return this.validateTuitionCalcForm.get('dataForEnrolmentCancelation.behaviourPatternCancelationCode');
  }

  get numberTimesModification() {
    return this.validateTuitionCalcForm.get('numberTimesModificationFeeAppliedBefore');
  }

  get numberCreditsCancelled() {
    return (this.validateTuitionCalcForm.get('listProgramOfRegistration') as FormArray).at(0)
      .get('numberCreditsCancelled');
  }

  get numberCreditForProgramRegistration() {
    return (this.validateTuitionCalcForm.get('listProgramOfRegistration') as FormArray).at(0)
      .get('numberCreditsForProgramRegistration');
  }

  get numberCreditsForProgramRegistrationCurrentPeriod() {
    return (this.validateTuitionCalcForm.get('listProgramOfRegistration') as FormArray).at(0)
      .get('numberCreditsForProgramRegistrationCurrentPeriod');
  }

  get numberCreditsForProgramRegistrationCompleted() {
    return (this.validateTuitionCalcForm.get('listProgramOfRegistration') as FormArray).at(0)
      .get('numberCreditsForProgramRegistrationCompleted');
  }

  onSubmit(): void {
    this.formSubmit = true;
    if (this.validateTuitionCalcForm.invalid) {
      this.validateTuitionCalcForm.markAllAsTouched();
      return;
    }

    if (this.isPatternModification && !this.applyValidatorByModification()) {
      return;
    }

    if (this.isPatternModification && this.numberCreditsCancelled?.value > this.numberCreditForProgramRegistration?.value) {
      this.showError('Error de parámetros', 'Los numero de creditos cancelados no pueden ser superior a la registrados');
      return;
    }

    this.setParamsForSend();

    if (this.isPatternCancellation) {

      // 1) Validar formulario de cancelación
      if (!this.applyValidatorByCancellation()) {
        return;
      }

      // 2) Validar que existe operación previa
      if (!this.lastOperationResultDto) {
        this.showError(
          'Error en la cancelación',
          'Debe existir previamente un alta o una modificación de la matrícula. ' +
          'La cancelación se ejecutará siempre a partir de la última operación realizada.'
        );
        return;
      } else {
        this.paramTutitionCalculationDto.dataForEnrolmentCancelation.lastOperationResult = this.lastOperationResultDto;
      }

    }

    this.sharedService.showSpinnerModal();
    const dto = this.paramTutitionCalculationDto;
    const patternUrl =
      this.isPatternModification
        ? this.tuitionCalculationService.consultModificationTuition(dto)
        : this.isPatternCancellation
          ? this.tuitionCalculationService.consultCancellationTuition(dto)
          : this.tuitionCalculationService.consultHighTuition(dto);

    patternUrl.subscribe({
      next: response => {
        if (response != null) {
          console.log(response);
          this.economicCalculationResponseDto = structuredClone(response);
          this.sharedService.hideSpinnerModal();
          this.setLastOperationResult(this.economicCalculationResponseDto);
        }
      }, error: error => {
        console.log(error);
        this.sharedService.hideSpinnerModal();
        const fieldErrors = error?.error?.fieldError;
        const msg =
          Array.isArray(fieldErrors) && fieldErrors.length
            ? fieldErrors.map((e: any) => e?.message ?? '').filter(Boolean).join('\n')
            : (error?.error?.message ?? error?.message ?? 'Error inesperado');
        this.showError('Error al consultar el cálculo', msg);
      }
    });

  }


  private setParamsForSend(): void {
    // Almacenamos el listado de descuentos no acumulables
    this.validateTuitionCalcForm.setControl(
      'listSelectedDiscount',
      this.formBuilder.array(
        this.validateTuitionCalcForm.value.idDiscountCode
          ? [this.formBuilder.group({ idDiscountCode: this.validateTuitionCalcForm.value.idDiscountCode })]
          : []
      )
    );

    this.validateTuitionCalcForm.setControl(
      'listOptionalAdministrativeFee',
      this.formBuilder.array(
        this.validateTuitionCalcForm.value.idFeeCodeOptional
          ? [this.formBuilder.group({ idFeeCodeOptional: this.validateTuitionCalcForm.value.idFeeCodeOptional })]
          : []
      )
    );

    // Obtenemos los valores con RawValue() de está forma, no elimina del objeto aquellos valores que se descartan
    this.paramTutitionCalculationDto = this.validateTuitionCalcForm.getRawValue();

    if (this.validateTuitionCalcForm.value.idDiscountPromotionalCode != null) {
      this.paramTutitionCalculationDto.idDiscountPromotionalCode = this.validateTuitionCalcForm.value.idDiscountPromotionalCode;
    }

    /* Cuando se manipula los campos de importe fijo o porcentaje, al setear un valor u otro se queda vacío, 
    debemos de indicar a mano el 0 de lo contrario lo envía como cadena de texto vacía.*/
    if (this.paramTutitionCalculationDto.companyFixedAmount == 0) {
      this.paramTutitionCalculationDto.companyFixedAmount = 0;
    }
    if (this.paramTutitionCalculationDto.companyPaymentPercentage == 0) {
      this.paramTutitionCalculationDto.companyPaymentPercentage = 0;
    }
  }

  validateNumericInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Eliminamos las letras y permitismo un total de 30 digitos
    const cleaned = input.value.replace(/\D/g, '').slice(0, 30);
    input.value = cleaned;
  }

  onErrorModalClose() {
    this.showErrorModal = false;
  }

  private showError(title: string, message: string) {
    this.errorTitle = title;
    this.errorMessage = message;
    this.showErrorModal = true;
  }

  /**
   * Función encargada de filtrar el modelo por el idioma de la aplicación y ordenera el listado por Id's
   */
  private changeLanguageAndOrderSelectRateModel(): void {
    this.launcherService.getParamForLauncher().subscribe({
      next: response => {
        if (response.paramLauncherDto != null) {
          this.paramTutitionCalculationDto.rateModelDto =
            response.paramLauncherDto.rateModelDto.map((rm: any) => {
              return {
                ...rm,
                rateModelTraductionDto: rm.rateModelTraductionDto.filter((rmt: any) => rmt.languageDto.code.includes(this.currentLanguage))
              }
            });
        }
        // ordenamos por id del modelo de tasa
        this.paramTutitionCalculationDto.rateModelDto.sort((a: any, b: any) => a.idRateModel - b.idRateModel);

        // Almacenamos el listado de modelos inicial para su posterir filtrado
        this.initRateModelDto = this.paramTutitionCalculationDto.rateModelDto;

      }
    });
  }

  /**
   * Función encargada de cambiar el idoma de los desplegables, filtrar por codigos promocionales, etc...
   */
  private changeLanguageOtherSelect(): void {
    this.selectTaxAdminOptional = this.selectTaxAdminOptional
      .map((disc: any) => {
        return {
          ...disc,
          listDiscountDescription: disc.listOptionalAdministrativeFeetraduction.filter((d: any) => d.isoLanguageCode.includes(this.currentLanguage))
        }
      });

    this.selectDiscountPromotional = this.selectDisctNoAcumulative
      .filter((disc: any) =>
        disc.listDiscountDescription.some((d: any) => d.description.toLowerCase().includes('promocional')))
      .map((disc: any) => {
        return {
          ...disc,
          listDiscountDescription: disc.listDiscountDescription.filter((d: any) => d.isoLanguageCode.includes(this.currentLanguage))
        }
      });

    // Traducciónes al idioma con el que se está trabajando
    this.selectDisctNoAcumulative = this.selectDisctNoAcumulative
      .filter((disc: any) =>
        !disc.listDiscountDescription.some((d: any) => d.description.toLowerCase().includes('promocional')))
      .map((disc: any) => {
        return {
          ...disc,
          listDiscountDescription: disc.listDiscountDescription.filter((d: any) => d.isoLanguageCode.includes(this.currentLanguage))
        }
      });

    this.selectDisctAcumulative = this.selectDisctAcumulative
      .filter((disc: any) =>
        !disc.listDiscountDescription.some((d: any) => d.description.toLowerCase().includes('promocional')))
      .map((disc: any) => {
        return {
          ...disc,
          listDiscountDescription: disc.listDiscountDescription.filter((d: any) => d.isoLanguageCode.includes(this.currentLanguage))
        }
      })
  }

  cleanerCompanyFixedAmountOrPercent(fixedAmount: boolean, value: string): void {
    if (fixedAmount) {
      if (value === "") {
        this.enableFixedAndPercet();
      } else {
        this.validateTuitionCalcForm.get('companyFixedAmount')?.enable({ emitEvent: false });
        this.validateTuitionCalcForm.get('companyPaymentPercentage')?.disable({ emitEvent: false });
      }
    } else {
      if (value === "") {
        this.enableFixedAndPercet();
      } else {
        this.validateTuitionCalcForm.get('companyFixedAmount')?.disable({ emitEvent: false });
        this.validateTuitionCalcForm.get('companyPaymentPercentage')?.enable({ emitEvent: false });
      }
    }
  }

  enableFixedAndPercet(): void {
    this.validateTuitionCalcForm.get('companyFixedAmount')?.enable({ emitEvent: false });
    this.validateTuitionCalcForm.get('companyPaymentPercentage')?.enable({ emitEvent: false });
  }

  applyValidatorByModification(): boolean {
    if (this.isPatternModification) {
      this.behaviourPatterModification?.setValidators([Validators.required]);
      this.numberTimesModification?.setValidators([Validators.required, Validators.pattern(/^\d+$/)]);
      this.numberCreditsCancelled?.setValidators([Validators.required, Validators.pattern(/^\d+$/)]);
    } else {
      this.behaviourPatterModification?.clearValidators();
      this.numberTimesModification?.clearValidators();
      this.numberCreditsCancelled?.clearValidators();
    }

    this.behaviourPatterModification?.updateValueAndValidity({ emitEvent: false });
    this.numberTimesModification?.updateValueAndValidity({ emitEvent: false });
    this.numberCreditsCancelled?.updateValueAndValidity({ emitEvent: false });

    if (this.behaviourPatterModification?.invalid || this.numberTimesModification?.invalid
      || this.numberCreditsCancelled?.invalid || this.behaviourPatterModification?.value === ''
      || this.numberTimesModification?.value === '' || this.numberCreditsCancelled?.value === '') {
      this.validateTuitionCalcForm.markAllAsTouched();
      return false;
    }
    return true;
  }

  applyValidatorByCancellation(): boolean {
    if (this.isPatternCancellation) {
      this.numberCreditsForProgramRegistrationCurrentPeriod?.setValidators([Validators.required]);
      this.numberCreditsForProgramRegistrationCompleted?.setValidators([Validators.required]);
    } else {
      this.numberCreditsForProgramRegistrationCurrentPeriod?.clearValidators();
      this.numberCreditsForProgramRegistrationCompleted?.clearValidators();
    }

    this.numberCreditsForProgramRegistrationCurrentPeriod?.updateValueAndValidity({ emitEvent: false });
    this.numberCreditsForProgramRegistrationCompleted?.updateValueAndValidity({ emitEvent: false });

    if (this.numberCreditsForProgramRegistrationCurrentPeriod?.invalid || this.numberCreditsForProgramRegistrationCompleted?.invalid
      || this.numberCreditsForProgramRegistrationCurrentPeriod?.value === ''
      || this.numberCreditsForProgramRegistrationCompleted?.value === '') {
      this.validateTuitionCalcForm.markAllAsTouched();
      return false;
    }

    return true;
  }

  private setLastOperationResult(dto: EconomicCalculationResponseDto): void {
    if (!this.isPatternCancellation) {
      // Para poder ejecutar la cancelacíon, siempre almacenamos la última request ejecutada anteriormente
      this.lastOperationResultDto = {
        listShippingRatesApplied: dto.listShippingRatesApplied ?? [],
        listMandatoryAdministrativeFeeApplied: dto.listMandatoryAdministrativeFeeApplied ?? [],
        listSelectedProductsOfRegistration: dto.listSelectedProductsOfRegistration ?? [],
        listOptionalAdministrativeFeeApplied: dto.listOptionalAdministrativeFeeApplied ?? []
      };
    }
  }

}
